'use strict';
import * as $j_dev$002echeleb$002escalamigen$002epackage$0024package$0024$0024anon$00243 from "./dev.cheleb.scalamigen.package$package$$anon$3.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002ecollection$002e$002dString$002dParsers$0024 from "./scala.collection.-String-Parsers$.js";
var $p;
/** @constructor */
function $c_Lsamples_package$package$ExtraInt$() {
  this.Ml = null;
  this.Mm = false;
}
export { $c_Lsamples_package$package$ExtraInt$ as $c_Lsamples_package$package$ExtraInt$ };
$p = $c_Lsamples_package$package$ExtraInt$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_package$package$ExtraInt$;
/** @constructor */
function $h_Lsamples_package$package$ExtraInt$() {
}
export { $h_Lsamples_package$package$ExtraInt$ as $h_Lsamples_package$package$ExtraInt$ };
$h_Lsamples_package$package$ExtraInt$.prototype = $p;
$p.V2 = (function() {
  if ((!this.Mm)) {
    this.Ml = new $j_dev$002echeleb$002escalamigen$002epackage$0024package$0024$0024anon$00243.$c_Ldev_cheleb_scalamigen_package$package$$anon$3(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => {
      $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
      return $j_scala$002ecollection$002e$002dString$002dParsers$0024.$m_sc_StringParsers$().Ch(_$1$2);
    })), 0);
    this.Mm = true;
  }
  return this.Ml;
});
var $d_Lsamples_package$package$ExtraInt$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_package$package$ExtraInt$, "samples.package$package$ExtraInt$", ({
  rh: 1
}));
export { $d_Lsamples_package$package$ExtraInt$ as $d_Lsamples_package$package$ExtraInt$ };
var $n_Lsamples_package$package$ExtraInt$;
function $m_Lsamples_package$package$ExtraInt$() {
  if ((!$n_Lsamples_package$package$ExtraInt$)) {
    $n_Lsamples_package$package$ExtraInt$ = new $c_Lsamples_package$package$ExtraInt$();
  }
  return $n_Lsamples_package$package$ExtraInt$;
}
export { $m_Lsamples_package$package$ExtraInt$ as $m_Lsamples_package$package$ExtraInt$ };
